import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'

export const CategoryTile = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`

export const ImageLink = styled.a`
  display: block;
  width: 100%;
  text-decoration: none;
`

export const ImageContainer = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;

  .react-loading-skeleton {
    aspect-ratio: 4/5;

    .safari-lower-than-15 & {
      padding-top: 125%;
    }
  }
`

export const Image = styled(ResponsiveImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 4/5;
  display: block;

  .safari-lower-than-15 & {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export const ImagePlaceholder = styled.div`
  width: 100%;
  aspect-ratio: 4/5;
  background-color: ${({ theme }) =>
    theme.colors.skeleton?.baseColor || '#f0f0f0'};
`

export const TextContainer = styled.div`
  padding: 1rem 0 0;
`

export const TitleLink = styled.a`
  text-decoration: none;
  color: inherit;
`

export const Title = styled.h3`
  font-family: Jost;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 125%;
  letter-spacing: 0px;
  margin: 0;

  .react-loading-skeleton {
    height: 2rem;
    width: 80%;
  }
`
